<h1 class="mb-tt">Mis beneficios</h1>
<p class="mb-sub">Los beneficios se aplican solos cuando te identificás, en tienda y online.</p>

<loading-indicator *ngIf="isLoading"></loading-indicator>

<ng-container *ngIf="!isLoading">

  <!-- General no tiene beneficios de descuento: se muestra el camino a Aliado. -->
  <div class="mb-general" *ngIf="esGeneral">
    <b>Todavía no tenés beneficios de descuento</b>
    <span>Sumás puntos en cada compra, en tienda y online. Cuando llegues a Aliado
      empezás a acceder a los descuentos del Club.</span>
  </div>

  <div class="mb-tiers">
    <section class="mb-tier" *ngFor="let n of niveles" [class.actual]="n.actual">
      <header class="mb-tier-hd">
        <h2>{{ n.nombre }}</h2>
        <span class="mb-ahora" *ngIf="n.actual">Tu nivel</span>
      </header>
      <p class="mb-rango">{{ n.rango }}</p>

      <ul class="mb-lista">
        <li *ngFor="let b of n.beneficios">
          <span class="mb-dest" *ngIf="b.destacado">{{ b.destacado }}</span>
          <span class="mb-txt">{{ b.texto }}</span>
        </li>
      </ul>
    </section>
  </div>

  <section class="mc-blk">
    <div class="mc-hd"><h2>Cómo se usan</h2></div>
    <div class="mb-card">
      <b>En tienda</b>
      <p>Decí tu número de documento en la caja. El descuento se aplica solo.</p>
      <b class="mb-sep">Online</b>
      <p>Iniciá sesión antes de pagar. Vas a ver el precio de socio en el carrito.</p>
    </div>
  </section>

</ng-container>
